export const SelectErrorTheme = (theme:any) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: '#FFC7CE', // Lighter background color for the error state
    primary: '#FF5A5F', // Border color for the error state
  },
});

export const SelectSuccessTheme = (theme: any) => ({
  ...theme,
  border: "1px solid green",
  colors: {
    ...theme.colors,
    primary25: '#86efac',
    primary: '#22c55e',
  },
  // Add custom styles for the focused state
  components: {
    Control: (provided: any, state: any) => ({
      ...provided,
      border: state.isFocused ? '1px solid green' : '1px solid green',
      boxShadow: state.isFocused ? '0 0 0 1px green' : 'none',
      '&:hover': {
        borderColor: 'green',
      },
    }),
  },
});

  